export enum EncerramentoAutomaticoStatusEnum {

  EM_PROCESSAMENTO ="Em processamento",
  PROCESSADO_COM_SUCESSO = "Processado com sucesso",
  ERRO = "Erro ao processar"
}
